import React from "react";
import "./StatementCard.scss";
const StatementCard = ({ statement }) => {
  if (!statement) return null;
  return (
    <div className="StatmentsBox">
      <p className="statement-title">{statement.title}</p>
      <hr className="customize-hr" />
    </div>
  );
};
export default StatementCard;
